import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ResizeObserverErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Check if it's a ResizeObserver error
    if (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      // Don't update state for ResizeObserver errors, just suppress them
      return { hasError: false };
    }
    // For other errors, update state
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Suppress ResizeObserver errors
    if (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      console.log('ResizeObserver error suppressed:', error.message);
      return;
    }
    
    // Log other errors normally
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ResizeObserverErrorBoundary;
